// Blog post: HVAC Contractor Pasadena CA
// Target keyword: HVAC Contractor Pasadena CA

const post = {
  slug: "hvac-contractor-pasadena",
  category: "HVAC · Pasadena",
  title: "How to Find a Reliable HVAC Contractor in Pasadena, CA",
  summary:
    "What Pasadena homeowners need to know about HVAC repair, replacement, and installation — licensing, costs, what to ask, and how to get fair quotes.",
  readTime: "5 min read",
  sections: [
    {
      heading: "HVAC in Pasadena — why it matters more than most cities",
      body: "Pasadena regularly hits 90°F+ in summer, often climbing over 100°F during heat events, making a functioning HVAC system critical. At the same time, many of the city's older Craftsman and Spanish Colonial homes were built without central air — adding or upgrading HVAC in these properties requires careful planning around existing ductwork or going ductless. A qualified HVAC contractor in Pasadena CA understands both old and new systems.",
    },
    {
      heading: "Step 1: Verify the C-20 HVAC license",
      body: "HVAC contractors in California must hold a C-20 (warm-air heating, ventilating, and air conditioning) license from the CSLB for projects over $500. Verify at cslb.ca.gov. Also confirm they carry liability insurance and workers' compensation. For refrigerant handling, the technician must also hold an EPA 608 certification.",
    },
    {
      heading: "Common HVAC jobs in Pasadena",
      body: "The most frequent calls for an HVAC contractor in Pasadena CA include AC repair and tune-up, full system replacement (air handler + condenser), ductless mini-split installation for older homes, duct cleaning and sealing, furnace repair and replacement, and thermostat upgrades (including smart thermostats). Be specific about what you need when requesting quotes so you can compare them accurately.",
    },
    {
      heading: "Ductless mini-splits — the right solution for older Pasadena homes",
      body: "Many Pasadena bungalows and older properties don't have existing duct systems. Ductless mini-split systems are an efficient solution — they require only a small hole in the wall for refrigerant lines and can cool or heat individual rooms with precision. A good HVAC contractor in Pasadena CA will walk you through the sizing and placement options before recommending a system.",
    },
    {
      heading: "What a proper HVAC quote should include",
      body: "A complete HVAC quote should specify the equipment brand and model, SEER rating (efficiency), warranty on equipment and labor, whether permits are included, installation timeline, and whether old equipment removal and disposal is covered. Get at least three quotes for any full system replacement.",
    },
    {
      heading: "Ready to find an HVAC contractor in Pasadena?",
      body: "BuildBright helps Pasadena homeowners submit project requests and organize project intake through available contractors. Submit your project at buildbright.app so BuildBright can help coordinate next steps — free for homeowners to submit."
    },
  ],
};

export default post;
